module.exports = __webpack_public_path__ + "img/sec5_2.b0bd51ca.jpg";